<template>
  <ckeditor
      :editor="editor"
      :value="value"
      :config="finalConfigs"
      @input="(value, e) => $emit('input', value, e)"
  ></ckeditor>
</template>

<script>
import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor';
import EssentialsPlugin from '@ckeditor/ckeditor5-essentials/src/essentials';
import BoldPlugin from '@ckeditor/ckeditor5-basic-styles/src/bold';
import Heading from '@ckeditor/ckeditor5-heading/src/heading';
import ItalicPlugin from '@ckeditor/ckeditor5-basic-styles/src/italic';
import LinkPlugin from '@ckeditor/ckeditor5-link/src/link';
import ParagraphPlugin from '@ckeditor/ckeditor5-paragraph/src/paragraph';

const DEFAULT_PLUGINS = [
  EssentialsPlugin,
  BoldPlugin,
  Heading,
  ItalicPlugin,
  LinkPlugin,
  ParagraphPlugin,
];

export default {
  props: {
    value: {
      required: true,
    },
    editorConfigs: {
      type: Object,
      required: false,
    },
  },

  data () {
    return {
      editor: ClassicEditor,
      editorData: '',
      finalConfigs: null,
    };
  },

  created () {
    let config = this.editorConfigs ?? {};
    let plugins = [...DEFAULT_PLUGINS];

    if (!!this.editorConfigs) {
      plugins = [
        ...config.plugins,
        ...plugins
      ];
    }

    config.plugins = plugins;

    this.finalConfigs = config;
  },
};
</script>
